import { Box } from '@rover/kibble/core';
import FloatingFooter from '@rover/react-lib/src/components/utils/FloatingFooter';
import DogTrainingButton from '@rover/react-lib/src/pages/landing/SeoLocation/pages/DogTraining/components/DogTrainingButton';
import emitMetricOnCtaClick from '@rover/react-lib/src/pages/landing/ServiceLanding/components/emitMetricOnCtaClick';
import { ServiceLandingEnum } from '@rover/types/src/ServiceLanding';

export type TrainingCTAProps = {
  children?: React.ReactNode;
  serviceLandingType: ServiceLandingEnum;
  goodPupLink?: string;
};

const TrainingFloatingFooterCTA = (props: TrainingCTAProps): JSX.Element => (
  <FloatingFooter>
    <Box my={['2x', '1x']} width="100%" textAlign="center">
      {props.children}
      <DogTrainingButton
        href={props.goodPupLink}
        rel="nofollow"
        target="_blank"
        width={['100%', '370px']}
        variant="primary"
        onClick={() => {
          emitMetricOnCtaClick({
            component: 'footer',
            slug: props.serviceLandingType || 'unknown',
          });
        }}
      >
        Start your free 7-day trial
      </DogTrainingButton>
    </Box>
  </FloatingFooter>
);

export default TrainingFloatingFooterCTA;
